// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_height_50_scroll__-WX\\+y {
  /*max-height: 50%;
  overflow-y: scroll;*/
}
`, "",{"version":3,"sources":["webpack://./src/styles/Menu.module.css"],"names":[],"mappings":"AAAA;EACE;sBACoB;AACtB","sourcesContent":[".height_50_scroll {\n  /*max-height: 50%;\n  overflow-y: scroll;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"height_50_scroll": `Menu_height_50_scroll__-WX+y`
};
export default ___CSS_LOADER_EXPORT___;
